export default {
  isLoading: false,
  invoices: [],
  invoicesHistory: [],
  stats: {},
  totalARBalance: 0,
  totalDisputedARBalance: 0,
  selected: [],
};
